var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { potentiallySecuredStorageProvider } from '../../compatibility';
import asyncStorageProvider from './asyncStorageProvider';
import storageProviderWrapper from './storageProviderWrapper';
import StorageKey from './StorageKey';
import { Metric } from '../../metrics';
import { toErrorMessage } from '../../util/ErrorHelper';
import TENANT_ID from '../../config/TenantId';
/**
 * Returns a persisted value asynchronously, and util functions to update and delete it.
 * https://evergreen.corp.amazon.com/atoz-developer-program/develop/react_native_development/hooks/#usepersistedobject
 */
function usePersistedObject(tenantId, objectKey, defaultValue, sensitive = true) {
    const uniqueTenantKeyForObject = StorageKey(tenantId, objectKey);
    const [restored, setRestored] = useState(false);
    const [objectState, setObjectState] = useState(null);
    const storage = sensitive ? potentiallySecuredStorageProvider : asyncStorageProvider;
    const storageProvider = storageProviderWrapper(storage);
    useEffect(() => {
        storageProvider
            .getObjectWithKey(uniqueTenantKeyForObject, defaultValue)
            .then((storedObject) => {
            setObjectState(storedObject);
            setRestored(true);
        })
            .catch((error) => {
            Metric('GetObjectWithKeyError', TENANT_ID, {
                attributes: { error: toErrorMessage(error) },
            }).put();
        });
    }, []);
    const clearObject = () => __awaiter(this, void 0, void 0, function* () {
        yield storageProvider.deleteObjectWithKey(uniqueTenantKeyForObject);
        setObjectState(null);
    });
    const setObject = (newObject) => __awaiter(this, void 0, void 0, function* () {
        yield storageProvider.setObjectWithKey(uniqueTenantKeyForObject, newObject);
        setObjectState(newObject);
    });
    return [objectState, setObject, clearObject, restored];
}
export { usePersistedObject };
//# sourceMappingURL=usePersistedObject.js.map